import { Instance, types } from 'mobx-state-tree';

export const VoucherDetails = types.model('VoucherDetails', {
  amount: types.maybe(types.number),
  createdCustomerId: types.maybe(types.string),
  code:types.number,
  currency: types.string,
  isExpired: types.boolean,
});

export type VoucherDetails = Instance<typeof VoucherDetails>;
